<div class="card section-card mb-3">
  <div class="card-header d-flex align-items-center justify-content-between gap-2">
    <span>{{ 'i18n.domain.theme-showcase.logo.title' | translate }}</span>
    <app-collapse-button [isExpanded]="isExpanded" (toggleExpand)="toggle()"></app-collapse-button>
  </div>

  @if (isExpanded) {
    <div class="card-body">
      <div class="tenant-logo-preview mt-3">
        <div class="tenant-logo-preview__header">
          {{ 'i18n.domain.theme-showcase.tenantTheme.logoPreviewTitle' | translate }}
        </div>
        <div class="tenant-logo-preview__frame">
          <img
            class="tenant-logo-preview__image"
            [src]="previewUrl"
            [alt]="'i18n.domain.theme-showcase.tenantTheme.logoPreviewAlt' | translate" />
        </div>
        <small class="text-body-secondary d-block mt-2">
          @if (hasCustomLogo) {
            {{ 'i18n.domain.theme-showcase.tenantTheme.logoPreviewCustomInfo' | translate }}
          } @else {
            {{ 'i18n.domain.theme-showcase.tenantTheme.logoPreviewDefaultInfo' | translate }}
          }
        </small>
      </div>
    </div>
  }
</div>
